import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import api from './api/api'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueParticles from '@/lib/vue-particles'

import dataV from '@jiaminghi/data-view'
import VueAnimateNumber from 'vue-animate-number'

Vue.use(VueAnimateNumber)

Vue.use(VueAxios, axios,api)
Vue.use(ElementUI);
Vue.use(dataV)
Vue.use(VueParticles)
Vue.config.productionTip = false
Vue.prototype.$api = api

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
